import { OrcaApi } from "./OrcaApi";
import { OrcaPlayer } from "./OrcaPlayer";

window.orcas = window.orcas || [];
window.OrcaPlayer = window.OrcaPlayer || new OrcaApi();
window.dataLayer = window.dataLayer || [];
customElements.get("orca-player") ||
  customElements.define("orca-player", OrcaPlayer);

window.orca = window.orca || {};
window.orca.version = window.orca.version || {};
window.orca.version["orca-script"] = VERSION;
